module.exports = __webpack_public_path__ + "static/media/error.222d810d.svg";